module.exports = require("tiny-worker");